import React from "react";
import { FaSearch, FaBell, FaSignOutAlt, FaStore } from "react-icons/fa";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";

import "./Header.css";

const Header = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const shopName = localStorage.getItem("storeName");
	const userInfo = useSelector((state) => state.analysisData.userInfo);
	const isDashboard =
		location.pathname === "/dashboard" ||
		location.pathname === "/" ||
		location.pathname === "/delete-account" ||
		location.pathname === "/profile-account" ||
		location.pathname === "/login-logs";
	return (
		<header className="bg-white shadow-sm z-50 sticky top-0 left-0 right-0">
			<nav className="bg-white shadow-sm ">
				<div className="px-6 sm:px-6">
					<div className="flex justify-between items-center h-16">
						{/* Left side - Logo and nav */}
						<div className="flex items-center space-x-8">
							<div className="flex-shrink-0 flex items-center">
								{/* <div className="w-10 h-10 rounded-lg bg-gradient-to-r from-primary-500 to-secondary-500 flex items-center justify-center text-white">
                  <i className="fas fa-chart-network text-xl"></i>
                </div> */}
								<div class=" p-3  ">
									{/* <i class="fas fa-chart-line text-indigo-600 text-4xl"></i> */}
									<img src="/rebato.png" width={50} />
								</div>
								<span className="text-xl font-bold text-gray-900 font-display">
									Rebato
								</span>
							</div>

							{/* Navigation links */}
							<div className="hidden sm:flex sm:space-x-4">
								<NavLink
									to="/dashboard"
									className={({ isActive }) =>
										`flex items-center px-3 py-2 text-sm font-medium rounded-lg ${isActive
											? "text-blue-600 bg-blue-50"
											: "text-gray-900 hover:text-gray-900 hover:bg-gray-100"
										}`
									}
								>
									<i className="fas fa-tachometer-alt mr-2"></i>
									Dashboard
								</NavLink>
								<NavLink
									to="/setting"
									className={({ isActive }) =>
										`flex items-center px-3 py-2 text-sm font-medium rounded-lg ${isActive
											? "text-blue-600 bg-blue-50"
											: "text-gray-900 hover:text-gray-900 hover:bg-gray-100"
										}`
									}
								>
									<i className="fas fa-cog mr-2"></i>
									Setting
								</NavLink>

								{userInfo.roles.includes("admin") && (
									<>
										<NavLink
											to="/profile-account"
											className={({ isActive }) =>
												`flex items-center px-3 py-2 text-sm font-medium rounded-lg ${isActive
													? "text-blue-600 bg-blue-50"
													: "text-gray-500 hover:text-gray-900 hover:bg-gray-100"
												}`
											}
										>
											<i className="fas fa-user mr-2"></i>
											Profile
										</NavLink>


									</>
								)}
								<NavLink
									to="/login-logs"
									className={({ isActive }) =>
										`flex items-center px-3 py-2 text-sm font-medium rounded-lg ${isActive
											? "text-blue-600 bg-blue-50"
											: "text-gray-500 hover:text-gray-900 hover:bg-gray-100"
										}`
									}
								>
									<i className="fas fa-history mr-2"></i>
									Login Logs
								</NavLink>
								
							</div>
						</div>

						{/* Right side - User controls */}
						<div className="hidden sm:flex sm:items-center space-x-4">
							<button
								type="button"
								className="flex items-center px-3 py-2 text-sm font-medium rounded-lg text-gray-500 hover:text-gray-900 hover:bg-gray-100"
								onClick={() => {
									localStorage.removeItem("token");
									localStorage.removeItem("userInfo");
									navigate("/login");
								}}
							>
								<i className="fas fa-sign-out-alt mr-2"></i>
								Logout
							</button>
							{/* <button
								type="button"
								className="p-1 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
								aria-label="View notifications"
							>
								<i className="fas fa-bell h-6 w-6"></i>
							</button>

							<button
								type="button"
								className="flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
								id="user-menu-button"
								aria-haspopup="true"
								aria-expanded="false"
							>
								<span className="sr-only">Open user menu</span>
								<img
									className="h-8 w-8 rounded-full"
									src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
									alt="User avatar"
								/>
							</button> */}
						</div>

						{/* Mobile menu button */}
						<div className="flex items-center sm:hidden -mr-2">
							<button
								type="button"
								className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500"
								aria-label="Open main menu"
								aria-expanded="false"
							>
								<span className="sr-only">Open main menu</span>
								<i className="fas fa-bars h-6 w-6"></i>
							</button>
						</div>
					</div>
				</div>
			</nav>
		</header>
	);
};

export default Header;
